import { render, staticRenderFns } from "./genericView.vue?vue&type=template&id=22f87d46&scoped=true&"
import script from "./genericView.vue?vue&type=script&lang=js&"
export * from "./genericView.vue?vue&type=script&lang=js&"
import style0 from "./genericView.vue?vue&type=style&index=0&id=22f87d46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f87d46",
  null
  
)

export default component.exports